import React from "react";
import { useParams } from "react-router-dom";
import { Row, Col } from "reactstrap";

const ProfileTabsView = ({ tab, onTabSelect }) => {
  const { type } = useParams();

  const tabStyle = (isActive) => ({
    borderRadius: "5px",
    backgroundColor: isActive ? "#000000" : "#DFDFDF",
    color: isActive ? "white" : "black",
    cursor: "pointer",
    width: '150px',
    padding: '10px',
    fontWeight: 500,
    fontSize: "14px",
    textAlign: "center",
  });

  return (
    <Row className="mx-2 py-2 justify-content-start">
      <Col
        xs="auto"
        style={{
          ...tabStyle(tab === 0),
          borderTopRightRadius: 0,
          borderBottomRightRadius: 0,
        }}
        onClick={() => onTabSelect(0)}
      >
        Profile
      </Col>
      <Col
        xs="auto"
        style={{
          ...tabStyle(tab === 1),
          borderRadius: 0,
        }}
        onClick={() => onTabSelect(1)}
      >
        Scrapped Data
      </Col>
      <Col
        xs="auto"
        style={{
          ...tabStyle(tab === 2),
          borderRadius: 0,
        }}
        onClick={() => onTabSelect(2)}
      >
        More Info
      </Col>
      <Col
        xs="auto"
        style={{
          ...tabStyle(tab === 3),
          borderTopLeftRadius: 0,
          borderBottomLeftRadius: 0,
        }}
        onClick={() => onTabSelect(3)}
      >
        Engagements
      </Col>
    </Row>
  );
};

export default ProfileTabsView;
